import SHCircular from './src/circular.vue';


/**
 * 利用Cavans绘制圆环
 */

/* istanbul ignore next */
SHCircular.install = function(Vue) {
  Vue.component('sh-circular', SHCircular);
};
export default SHCircular;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/circular/index.js